import { TransportOrderIdView } from '../../../../models/shipment-id-view.model';

export class ShipmentTransportOrderCommentsLoad {
  public static readonly type = '[ShipmentTransportOrderComments] Load';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderCommentsSave {
  public static readonly type = '[ShipmentTransportOrderComments] Save Comment';
  constructor(public payload: { transportOrder: TransportOrderIdView; comment: string }) {}
}

export class ShipmentTransportOrderCommentsInitialState {
  public static readonly type = '[ShipmentTransportOrderComments] Set Initial State';
}
